export const APPOINTMENT = 'APPOINTMENT';
export const MESSAGING = 'MESSAGING';

export const consultationTypes = [APPOINTMENT, MESSAGING];

export const consultationTypesMessages = {
  [APPOINTMENT]: {
    id: 'NewConsultationWizard.ConsultationTypeSelection.AppointmentTypeOption',
    defaultMessage: '** Appointment',
    icon: 'checkboard',
  },
  [MESSAGING]: {
    id: 'NewConsultationWizard.ConsultationTypeSelection.MessagingTypeOption',
    defaultMessage: '** Messaging',
    icon: 'chat-bubbles',
  },
};
